import React from "react";

const Dashboard = () => {
  return (
    <div>
      <h2>Welcome to the Dashboard</h2>
      <p>Here’s your React + Remos template layout.</p>
    </div>
  );
};

export default Dashboard;
